/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */

/**
 * Como a transferencia ao professor foi feita, **fora da plataforma**. Os
 * dois valores sao exatamente os que a §8.2 nomeia, e sao os mesmos do
 * tipo `settlement_method` do banco — nenhum meio de pagamento novo e
 * inventado aqui.
 *
 * Pagamento por qualquer outro meio nao tem valor verdadeiro nesta lista, e
 * o campo que a carrega e por isso opcional: a plataforma diz "nao
 * perguntei" em vez de afirmar algo falso sobre como o dinheiro saiu.
 * Acrescentar um terceiro meio e decisao comercial, e esta registrada como
 * pendencia.
 */
export type SettlementMethod = typeof SettlementMethod[keyof typeof SettlementMethod];


export const SettlementMethod = {
  pix: 'pix',
  bank_transfer: 'bank_transfer',
} as const;
